class Variation{
    periods = []; //Periodos
    product = null; //Producto
    schedule = null; //Horario
    duration = null; //ID semana o número semanas
    wooVariation = null; //Objeto del woocommerce
    fixedCosts = [];

    constructor(periods, product, schedule, duration, fullVariations){
        this.periods = periods;
        this.product = product;
        this.schedule = schedule;
        this.duration = duration;
        this.wooVariation = fullVariations.find(variation => {
            let attributes = variation && variation.attributes;
            let _duration = attributes && attributes.attribute_pa_durada && attributes.attribute_pa_durada;
            let _schedule = attributes && attributes.attribute_pa_horari;
            
            return _schedule == schedule && _duration == duration;
        });
        if(this.wooVariation && this.wooVariation.fixed_costs){
            this.fixedCosts = [this.wooVariation.fixed_costs];
            this.wooVariation.display_price = parseFloat(this.wooVariation.display_price);

            for(let fixedCost of this.fixedCosts){
                this.wooVariation.display_price += parseFloat(fixedCost.price);
            }
        }
    }

    periodsToString(){
        return this.periods.map(period => period.title).join(", ");
    }
}

export default Variation;